import { Button } from 'react-bootstrap';
import Jumbotron from './Jumbotron';
import React from 'react';
import heroBannerImg from '../assets/svg/hero-banner-img.svg';
import styled from 'styled-components';
import { useNavigate } from 'react-router';

const StyledJumbotron = styled(Jumbotron)`
  min-height: 360px;
  border-radius: 0;

  background: #822a9f no-repeat bottom right;

  @media (max-width: 768px) {
    min-height: auto;
  }

  @media (max-width: 1199px) {
    background-image: linear-gradient(270deg, #822a9f, #3c41ae 100%);
  }

  @media (min-width: 1200px) {
    background-image: url(${heroBannerImg});
    background-image:
      url(${heroBannerImg}), linear-gradient(270deg, #822a9f, #3c41ae 100%);
  }

  h1 {
    color: #fff;
    font-size: 56px;

    @media (max-width: 768px) {
      font-size: 30px;
    }
  }

  p {
    color: #fff;
    font-size: 22px;
    font-weight: 600;

    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  button {
    font-size: 16px;
  }
`;

const OnboardingHero = () => {
  const navigate = useNavigate();
  return (
    <StyledJumbotron className="w-100 mb-0 background-primary-gradient text-md-left text-center">
      <h1>Connect your smart meter</h1>
      <p className="py-3">
        Add your smart meter and start your journey to smart energy use
      </p>
      <p>
        <Button
          variant="primary"
          size="lg"
          onClick={() => navigate('/onboarding')}
          className="px-5 m-0">
          Connect your smart meter
        </Button>
      </p>
    </StyledJumbotron>
  );
};

export default OnboardingHero;
